import script from "./Expedientes.vue?vue&type=script&setup=true&lang=js"
export * from "./Expedientes.vue?vue&type=script&setup=true&lang=js"

import "./Expedientes.vue?vue&type=style&index=0&id=31c5411a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31c5411a"]])

export default __exports__